import { ActiveInactiveStatus, Colors, getDisplayDependsOnWidth, Images, PermissionList, RolePermission } from 'utils';
import { cardStyle } from '.';
import { DateRow, LinkRow, TextRow } from '..';
import React from 'react';

export function getTitleDisplay(givenTitle = '', givenValue = '', width, isBig) {
    const classes = cardStyle();

    const getCurrentValue = (value) => value;
    // getDisplayDependsOnWidth(value, width, 8, isBig ? 1440 : 1920);

    if (!givenTitle) {
        return '';
    }

    return typeof givenTitle === 'object' && typeof givenValue === 'object' ? (
        <div className={classes.titleBoxStyle}>
            {givenTitle.first && givenValue.first && (
                <p className={`${classes.titleStyle} several`}>{getCurrentValue(`${givenTitle.first}:`)}</p>
            )}
            {givenTitle.second && givenValue.second && (
                <p className={`${classes.titleStyle} several`}>{getCurrentValue(`${givenTitle.second}:`)}</p>
            )}
        </div>
    ) : (
        <p className={classes.titleStyle}>{getCurrentValue(`${givenTitle}:`)}</p>
    );
}

export function getValueDisplay(givenValue = '', givenTitle = '', width, isBig) {
    const classes = cardStyle();

    const getCurrentValue = (value) => getDisplayDependsOnWidth(value, width, 8, isBig ? 1440 : 1920);

    return typeof givenTitle === 'object' && typeof givenValue === 'object' ? (
        givenTitle.first === 'Status' ? (
            <div className={classes.valueBoxStyle}>
                {givenValue.first && givenTitle.first && (
                    <p className={`${classes.valueStyle} several statusStyle ${ActiveInactiveStatus(givenValue.first)}`}>
                        {givenValue.first}
                    </p>
                )}
                {givenValue.second && givenTitle.second && (
                    <p className={`${classes.valueStyle} several`}>{getCurrentValue(givenValue.second)}</p>
                )}
            </div>
        ) : (
            <div className={classes.valueBoxStyle}>
                {givenValue.first && givenTitle.first && <p className={`${classes.valueStyle} several`}>{givenValue.first}</p>}
                {givenValue.second && givenTitle.second && (
                    <p className={`${classes.valueStyle} several`}>{getCurrentValue(givenValue.second)}</p>
                )}
            </div>
        )
    ) : givenTitle === 'Website' ? (
        <a href={givenValue} target="_blank" rel="noopener noreferrer" className={classes.linkStyle}>
            {getCurrentValue(givenValue)}
        </a>
    ) : givenTitle === 'Status' ? (
        <p className={`${classes.valueStyle} statusStyle ${ActiveInactiveStatus(givenValue)}`}>{givenValue}</p>
    ) : (
        <p className={classes.valueStyle}>{getCurrentValue(givenValue)}</p>
    );
}

export function getCardBorderTop(cardTitle) {
    switch (cardTitle) {
        case 'General Info':
            return `4px solid ${Colors.BackgroundBlue}`;
        case 'Address':
            return `4px solid ${Colors.BackgroundMango}`;
        case 'Other Details':
            return `4px solid ${Colors.ThemeRed}`;
        case 'Employment':
            return `4px solid ${Colors.BackgroundMango}`;
        case 'Clients':
            return `4px solid ${Colors.ThemeRed}`;

        default:
            return 'unset';
    }
}
